module.exports = __webpack_public_path__ + "img/router_left.1b51d13f.svg";